import React from "react";

export const CabinetImportDossiersAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/cabinet/clients/import",
      component: React.lazy(() => import("./CabinetImportDossiersApp")),
    },
  ],
};
